import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../Services/authService";
import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const handleLogin = async () => {
    if(email && password){
      let payload = { email, password };
      navigate("/dashboard");
      const res = await login(payload);
      const { ok, token } = res;
      if (ok) {
        localStorage.setItem("access_token", token);
        navigate("/dashboard");
      }
    }else{
      toast.error("Email and Password required.")
    }
  };

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Login</h1>
                  <p className="account-subtitle">Access SuperCounsellor CMS</p>

                  <form>
                    <div className="form-group">
                      <label className="form-control-label">Email</label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-control-label">Password</label>
                      <div className="pass-group">
                        <input
                          required
                          type="password"
                          className="form-control pass-input"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </div>
                    <Link>
                      <button
                        className="btn btn-lg btn-block btn-primary w-100"
                        type="submit"
                        onClick={handleLogin}
                      >
                        Login
                      </button>
                    </Link>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
